import React from "react";
import PropTypes from "prop-types";
import { PaymentMethodListItem } from "components/Pages/Payments/PaymentMethods";
import Dropdown from "./Dropdown";

const propTypes = {
  paymentMethods: PropTypes.array.isRequired,
  includeStatementCredit: PropTypes.bool,
  didSelect: PropTypes.func
};

function partition(array, isValid) {
  return array.reduce(
    ([pass, fail], elem) => {
      return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []]
  );
}

const PaymentDropdown = ({
  paymentMethods = [],
  defaultElementId,
  didSelect,
  includeStatementCredit,
  excludeBankAccounts = false,
  disabled = false,
  dropDownClassName,
  listItemClassName,
  listItemInnerClassName,
  listItemImageClassName,
  selectedElement = false,
  showBankName = false
}) => {
  const methods = [];
  if (!excludeBankAccounts) {
    if (defaultElementId) {
      // Make element with default id appear first
      const [selected, rest] = partition(
        paymentMethods,
        m => m.id === defaultElementId
      );
      methods.push(...selected, ...rest);
    } else {
      methods.push(...paymentMethods);
    }
  }
  if (includeStatementCredit) {
    methods.push({ type: "Statement Credit" });
  }
  return (
    <Dropdown
      elements={methods}
      disabled={disabled}
      selectedElement={selectedElement}
      component={(paymentMethod, componentProps) => (
        <PaymentMethodListItem
          method={paymentMethod}
          showBankName={showBankName}
          {...componentProps}
        />
      )}
      componentProps={{
        className: listItemClassName,
        innerClassName: listItemInnerClassName,
        imageClassName: listItemImageClassName
      }}
      didSelect={didSelect}
      className={dropDownClassName}
    />
  );
};

PaymentDropdown.propTypes = propTypes;

export default PaymentDropdown;
